var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Grid',{staticClass:"dense",staticStyle:{"height":"300px"},attrs:{"datagrid":_vm.roles,"dbref":"Arch.RolePosition","dbparams":_vm.dbparams,"columns":[
      {
        name: 'Menu',
        value: 'RolePositionName',
        editable: {
          com: 'Input',
        },
      },
      {
        name: 'Admin?',
        value: 'IsAdmin',
        editable: {
          com: 'Checkbox',
        },
      } ]},on:{"update:datagrid":function($event){_vm.roles=$event}},scopedSlots:_vm._u([{key:"row-IsAdmin",fn:function(ref){
    var row = ref.row;
return [_c('div',{attrs:{"center":""}},[_c('v-icon',[_vm._v(" "+_vm._s(row.IsAdmin ? 'mdi-check-box-outline' : 'mdi-crop-square')+" ")])],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }